<template lang="pug">
v-dialog(v-model='settingsDialog' max-width='750')
    template(v-if="!isHiddenActivator" v-slot:activator='{ on }')
        v-btn(icon v-on='on' :class="buttonClasses")
            v-icon mdi-cog
    v-card
        v-card-title.text-h5 {{ title }}
        v-card-text.mt-3
            v-row
                CookieSettingItem(
                    v-for='(setting, index) in cookieSettingsHelperMap'
                    :key='index'
                    :setting="setting"
                    :local-settings="localSettings"
                    :cookie-settings-object="cookieSettingsObject"
                    @reactive-change="onReactiveChange"
                )
        v-divider
        v-card-text
            | * Note - clearing your cache will reset these settings to default.

        v-card-actions
            v-spacer
            v-btn(outlined color='primary' ripple @click='closeDialog();') 
                v-icon mdi-close    
                | Close
            v-btn(outlined color='success' ripple @click='saveSettings();') 
                v-icon mdi-check
                | Save
</template>

<script lang="ts">
import Vue from 'vue';

// Components
import CookieSettingItem from '@/components/shared/cookie_setting_item.vue';

// Helpers
import { initCookies, updateCookies, CookieSettingsHelper } from '@/helpers/cookie';

export default Vue.extend({
    data() {
        return {
            localSettings: {},
            settingsDialog: false,
        }
    },
    methods: {
        closeDialog() {
            this.settingsDialog = false;
        },
        getCheckboxValue(setting) {
            const val = this.localSettings[setting.varKey]
            return setting.isNegator ? !val : val
        },
        onCheckboxChange(value, setting) {
            this.localSettings[setting.varKey] = setting.isNegator ? !value : value;
            
            if (setting.reactive) {
                this.$emit('reactiveChange', setting, this.localSettings[setting.varKey]);
            }
        },
        onEnumChange(setting) {
            if (setting.reactive) {
                this.$emit('reactiveChange', setting, this.localSettings[setting.varKey]);
            }
        },
        onReactiveChange(setting, value) {
            if (setting.reactive) {
                this.$emit('reactiveChange', setting, value);
            }
        },
        init() {
            initCookies(this.cookieSettingsObject, this.cookieSettingsHelperMap);
            this.localSettings = {...this.cookieSettingsObject};
            this.$emit('init');
        },
        saveSettings() {
            // handle front end
            this.closeDialog();
            this.showSnackbar('success', 'Settings saved successfully');
            
            // update objects
            updateCookies(this.localSettings, this.cookieSettingsHelperMap);
            if (this.manualSave) {
                this.$emit('update', this.localSettings);
            } else {
                for (const key in this.localSettings) {
                    if (this.cookieSettingsObject.hasOwnProperty(key)) {
                        this.cookieSettingsObject[key] = this.localSettings[key];
                    }
                }
            }
        },
        setLocalSetting(key, value) {
            this.localSettings[key] = value;
        },
    },
    computed: {
    },
    components: {
        CookieSettingItem,
    },
    props: {
        buttonClasses: {
            type: Array,
            required: false,
        },
        cookieSettingsHelperMap: {
            type: Array as () => CookieSettingsHelper[],
            required: true,
            validator: function(value) {
                return value !== null;
            }
        },
        cookieSettingsObject: {
            type: Object,
            required: true,
            validator: function(value) {
                return value !== null;
            }
        },
        isHiddenActivator: {
            type: Boolean,
            required: false,
            default: false,
        },
        manualSave: {
            type: Boolean,
            required: false,
            default: true,
        },
        showSnackbar: {
            type: Function,
            required: true,
        },
        title: {
            type: String,
            required: false,
            default: 'Settings',
        },
    },
    watch: {

    },
    created() {
        this.init();
    },
    destroyed() {
    },
    mounted() {
    },
})
</script>

<style lang="scss" scoped>

.checkbox-wraper {
    margin: 0;
    padding: 0;
    display: flex;
    align-items: center;
}

</style>